<div class="copo-container" *ngIf="!isLoading; else loadingOrError">
	<div class="copo-section">
		<div class="copo-section-header title-block">
			<span translate>eorder.create.order.title</span>
		</div>
	</div>
	<div class="copo-section-body copo-grid">
		<div class="copo-grid-row">
			<div class="copo-grid-row-column width-content">
				<div class="card-content-info">
					<div class="card-content-label" translate>eorder.wizard.header.customer-order-number</div>
					<div class="card-content-value width-content "
						[matTooltip]="form.getFormCustomerOrderNumber().value">
						{{ form.getFormCustomerOrderNumber().value }}
					</div>
				</div>
			</div>
			<div class="copo-grid-row-column width-content">
				<div class="card-content-info">
					<div class="card-content-label" translate>eorder.wizard.order.soldto.name</div>
					<div class="card-content-value width-content" [matTooltip]="soldto ? soldto : UNDERSCORE">
						{{ soldto ? soldto : UNDERSCORE }} </div>
				</div>
			</div>
			<div class="copo-grid-row-column">
			</div>
		</div>
	</div>
	<div class="copo-section-body copo-grid">
		<div class="copo-grid-row">
			<div class="copo-grid-row-column width-content" *ngIf="currencyList && currencyList.length > 0">
				<div class="card-content-info">
					<div class="card-content-label" translate>eorder.wizard.summary.header.currency.po</div>
					<div class="card-content-value" [matTooltip]="form.getFormCurrency().value ? form.getFormCurrency().value : UNDERSCORE">
						{{ form.getFormCurrency().value ? getCurrencyDisplay(form.getFormCurrency().value) : UNDERSCORE }}
					</div>
				</div>
			</div>
			<div class="copo-grid-row-column">
			</div>
		</div>
	</div>
</div>
<div *ngIf="!isLoading" class="copo-container cart-title">
	<div class="cart-title-heading"> <span translate>eorder.wizard.product.modification.title.cart</span> </div>
	<ng-container *ngIf="form.getFormProducts().length > 0; else noItem;">
		<div class="cart-title-content"> {{form.getFormProducts().length}} <span translate>eorder.wizard.product.modification.title.items</span> </div>
	</ng-container>
	<ng-template #noItem>
		<div class="cart-title-content"><span translate>woe.noitems</span></div>
	</ng-template>
	<div class="cart-product-family">
		<span class="pf-sub-category">{{productFamily?.subCategoryDescription}}</span>
		<span class="pf-form">&nbsp;({{productFamily?.formDescription  | titlecase}})</span>
	</div>
</div>
<ng-container *ngIf="templatesInLoading.size === 0; else loadingOrError">
	<ng-container *ngIf="form.getFormProducts().length > 0; else noProducts;">
		<form novalidate autocomplete="off" [formGroup]="form">
			<div class="grid-column-one-full card-block">
				<copo-apply-all class="apply-all-block" *ngIf="form.getFormProducts().length > 0;"
					(applyAllEvent)="onApplyAll($event)" [businessTypes]="businessTypes" [displayShipTo]="displayShipTo" [defaultValues]="inputForApplyAll">
				</copo-apply-all>
				<div formArrayName="products">
					<div @deleteItemTrigger class="card-product-block" *ngFor="let product of productResultControl; let i=index" [formGroupName]="i" #rows>
						<div *ngIf="getValueByControlName(i, 'configErrMsg') !== '' && getValueByControlName(i, 'configErrMsg').length > 0" class="card-block copo-notification-block">
							<mat-icon svgIcon="alert" [attr.title]="'quapp.alert' | translate" class="copo-notification-icon copo-hint-warning wrap-error"></mat-icon>
							<div>
								<div class="card-header-label"> <b translate>eorder.wizard.product.itemnumber</b> &nbsp;<b>{{ i+1 | number: '3.' }}</b></div>
									{{getValueByControlName(i, 'configErrMsg')}}
							</div>
						</div>
						<div class="card-header copo-dark-theme" 
						[ngClass]="[getExpandPanelStatus(i) ? 'card-header-top-rounded':'card-header-rounded']">
							<div class="card-header-label card-header-div-block">
								<div class="header-label" translate>eorder.wizard.product.itemnumber</div>
								<div class="field-value"><span>{{ i + 1 | number: '3.' }}</span></div>
							</div>
							<!-- Steelgrade -->
							<mat-form-field *ngIf="!isFullyConfigured(i) && isVariable(i, 'steelGrade') else steelGradReadonly" subscriptSizing="dynamic" floatLabel="always">
								<mat-label translate>eorder.wizard.product.steelgrade</mat-label>
								<mat-select class="steel-grade-text-color" formControlName="steelGrade" (selectionChange)="simulationCallOnValueChange(i)"
									[value]="getValueByControlName(i, 'steelGrade')" [compareWith]="compareWithFn"
									[@appearAnimation]="getVariableFieldUpdatedState(i, 'steelGrade') ? 'highlight' : ''">
									<mat-option *ngIf="checkIfConfigValueInVariableList(i, 'steelGrade', getPossibleValues(i, 'steelGrade'))" [value]="getConfigValue(i, 'steelGrade')"
										[matTooltip]="getTranslationForCodeByIndex('steelGrade', i)">
										<span>{{getTranslationForCodeByIndex('steelGrade', i)}}</span>
									</mat-option>
									<mat-option *ngFor="let variableField of getPossibleValues(i, 'steelGrade')| copoSortOptions:false: variableconfig" [value]="variableField.code">
										<span>{{ variableField.value }}</span>
									</mat-option>
								</mat-select>
							</mat-form-field>
							<ng-template #steelGradReadonly>
								<div class="card-header-label card-header-div-block">
									<div class="header-label" translate>eorder.wizard.product.steelgrade</div>
									<div class="field-value" [matTooltip]="getSteelGradeDescription(i)" [@appearAnimation]="getVariableFieldUpdatedState(i, 'steelGrade') ? 'highlight' : ''">
										<span>{{getSteelGradeDescription(i)}}</span>
									</div>
								</div>
							</ng-template>

							<!-- Thickness -->
							<mat-form-field *ngIf="!isFullyConfigured(i) && isVariable(i, 'thicknessValue') else thicknessReadonly" subscriptSizing="dynamic" floatLabel="always">
								<mat-label translate>eorder.wizard.product.thickness</mat-label>
								<input matInput type="number" copoInputNumber formControlName="thicknessValue" (change)="simulationCallOnValueChange(i)"
									[min]="0" [decimalCount]="3" [formControl]="getControl(i, 'thicknessValue')" step="0.01" class="input-field-text"
									[@appearAnimation]="getVariableFieldUpdatedState(i, 'thicknessValue') ? 'highlight' : ''">
								<mat-icon matSuffix class="pencil-icon pencil-icon-white" svgIcon="copo_pencil"></mat-icon>
							</mat-form-field>
							<ng-template #thicknessReadonly>
								<div class="card-header-label card-header-div-block">
									<div class="header-label" translate>eorder.wizard.product.thickness</div>
									<div class="field-value" [@appearAnimation]="getVariableFieldUpdatedState(i, 'thicknessValue') ? 'highlight' : ''" [matTooltip]="getValueByControlName(i, 'thicknessValue')">
										<span>{{getValueByControlName(i, 'thicknessValue')}}</span>
									</div>
								</div>
							</ng-template>

							<!-- Width -->
							<mat-form-field *ngIf="!isFullyConfigured(i) && isVariable(i, 'widthValue') else widthReadonly" subscriptSizing="dynamic" floatLabel="always">
								<mat-label translate>eorder.wizard.product.width</mat-label>
								<input matInput class="input-field-text" type="number" formControlName="widthValue" (change)="simulationCallOnValueChange(i)"
								copoInputNumber [min]="1" [decimalCount]="0" [formControl]="getControl(i, 'widthValue')"
								[@appearAnimation]="getVariableFieldUpdatedState(i, 'widthValue') ? 'highlight' : ''">
								<mat-icon matSuffix class="pencil-icon pencil-icon-white" svgIcon="copo_pencil"></mat-icon>
							</mat-form-field>
							<ng-template #widthReadonly>
								<div class="card-header-label card-header-div-block">
									<div class="header-label" translate>eorder.wizard.product.width</div>
									<div class="field-value" [@appearAnimation]="getVariableFieldUpdatedState(i, 'widthValue') ? 'highlight' : ''" [matTooltip]="getValueByControlName(i, 'widthValue')">
										<span>{{getValueByControlName(i, 'widthValue')}}</span>
									</div>
								</div>
							</ng-template>

							<!-- Length -->
							<mat-form-field subscriptSizing="dynamic" *ngIf="isSheet && !isFullyConfigured(i) && isVariable(i, 'lengthValue') else lengthReadonly" floatLabel="always">
								<mat-label translate>batch.length</mat-label>
								<input matInput class="input-field-text" type="number" formControlName="lengthValue" (change)="simulationCallOnValueChange(i)"
								copoInputNumber [min]="1" [decimalCount]="0" [formControl]="getControl(i, 'lengthValue')"
								[@appearAnimation]="getVariableFieldUpdatedState(i, 'lengthValue') ? 'highlight' : ''">
								<mat-icon class="pencil-icon pencil-icon-white" svgIcon="copo_pencil" matSuffix></mat-icon>
							</mat-form-field>
							<ng-template #lengthReadonly>
								<div *ngIf="isSheet" class="card-header-label card-header-div-block">
									<div class="header-label" translate>batch.length</div>
									<div class="field-value" [@appearAnimation]="getVariableFieldUpdatedState(i, 'lengthValue') ? 'highlight' : ''" [matTooltip]="getValueByControlName(i, 'lengthValue')">
										<span>{{getValueByControlName(i, 'lengthValue')}}</span>
									</div>
								</div>
							</ng-template>

							<!-- Quantity -->
							<mat-form-field subscriptSizing="dynamic" class="card-container-column" floatLabel="always">
								<mat-label translate>eorder.wizard.product.quantity</mat-label>
								<input matInput class="input-field-text" type="number" formControlName="quantity"
								copoInputNumber [min]="0" [decimalCount]="2" step="0.01" [formControl]="getControl(i, 'quantity')">
								<mat-icon class="pencil-icon pencil-icon-white" svgIcon="copo_pencil" matSuffix></mat-icon>
							</mat-form-field>

							<!-- RDD type -->
							<mat-form-field subscriptSizing="dynamic" [hideRequiredMarker]="true" floatLabel="always">
								<mat-label translate>eorder.wizard.product.rdd.type</mat-label>
								<mat-select class="steel-grade-text-color" formControlName="rddType" [compareWith]="compareWithFn" [@appearAnimation]="isRddTypeUpdated[i] ? 'highlight' : ''">
									<mat-option *ngFor="let rddType of rddTypes" [value]="rddType.code">
										<span>{{ rddType.value }}</span>
									</mat-option>
								</mat-select>
							</mat-form-field>
							<!-- RDD Date -->
							<!-- week -->
							<mat-form-field subscriptSizing="dynamic" *ngIf="getValueByControlName(i, 'rddType') === 'W'" floatLabel="always">
								<mat-label translate>eorder.wizard.product.rdd</mat-label>
								<input
										matInput
										spellcheck="false"
										autocomplete="off"
										readonly
										[copoDatepicker]="startDatepicker"
										copoFormat="week"
										[min]="calStartDate"
										[max]="calEndDate"
										(click)="startDatepicker.open()"
										#startDateInput
										(ngModelChange)="updatePackageType(i)"
										(focus)="startDateInput.blur()"
										formControlName="rdd" [@appearAnimation]="isRddUpdated[i] ? 'highlight' : ''">
								<mat-datepicker-toggle matSuffix class="filter-icon multiple-sufix cal-icon-color" [for]="startDatepicker"></mat-datepicker-toggle>
								<mat-datepicker #startDatepicker></mat-datepicker>
							</mat-form-field>	
							<!-- day -->
							<mat-form-field subscriptSizing="dynamic" *ngIf="getValueByControlName(i, 'rddType') === 'D'" floatLabel="always">
								<mat-label translate>eorder.wizard.product.rdd</mat-label>
								<input matInput [matDatepicker]="picker"
								copoFormat="date"
								[min]="calStartDate"
								[max]="calEndDate"
								(ngModelChange)="updatePackageType(i)"
								formControlName="rdd" [@appearAnimation]="isRddUpdated[i] ? 'highlight' : ''">
								<mat-datepicker-toggle matSuffix  class="filter-icon multiple-sufix cal-icon-color" [for]="picker"></mat-datepicker-toggle>
								<mat-datepicker #picker></mat-datepicker>
							</mat-form-field>
							<div class="card-header-right card-action-block">
								<div class="status-icon-group" *ngIf="getValueByControlName(i, 'loader') !== 'true'; else simulationLoading">
									<mat-icon [class]="getSimulationStatus(i)" svgIcon="icon-status"></mat-icon>
								</div>
								<button type="button" mat-icon-button *ngIf="getValueByControlName(i, 'isSimulationCompleted') === 'true' else closedEye" class="card-container-column card-column-eye"><mat-icon class="copo-eye-closed copo-eye-icon-open" svgIcon="open_eye"></mat-icon></button>
								<ng-template #closedEye>
									<div class="card-column-eye">
										<mat-icon class="copo-eye-closed eye-closed-icon-white" svgIcon="closed_eye"></mat-icon>
									</div>
								</ng-template>
								<button type="button" mat-icon-button [matMenuTriggerFor]="menu">
									<mat-icon svgIcon="md:more_vert"></mat-icon>
								</button>
								<mat-menu #menu="matMenu" xPosition="before" yPosition="below">
									<button type="button" mat-menu-item [disabled]="getValueByControlName(i, 'loader') === 'true'" (click)="removeProduct(i)"><span translate>eorder.wizard.product.action.delete</span>
									</button>
									<button type="button" mat-menu-item [disabled]="getValueByControlName(i, 'loader') === 'true'" (click)="resetProduct(i)"><span translate>filter.reset</span>
									</button>
									<button type="button" mat-menu-item [disabled]="getValueByControlName(i, 'loader') === 'true' || disableDuplicateMenu()" (click)="duplicateProduct(i)"><span translate>eorder.wizard.product.action.duplicate</span>
									</button>
								</mat-menu>
								<div>
									<button type="button" mat-icon-button>
										<mat-icon [ngClass]="(getExpandPanelStatus(i))?'':'drop-down-rotate'"
											svgIcon="copo_dropdown" (click)="expandPanel(i)"></mat-icon>
									</button>
								</div>
							</div>
						</div>
						<mat-expansion-panel *ngIf="!isFullyConfigured(i)" [expanded]="isExpanded[i]">
							<ng-template matExpansionPanelContent>
								<!-- 2nd row -->
								<div class="card-content">
									<mat-form-field subscriptSizing="dynamic" class="copo-content-product card-header-double-span copo-form-field label-padding" (click)="$event.stopPropagation()">
										<mat-label class="label-size" translate>transport.mode</mat-label>
										<mat-select formControlName="transportMode" [compareWith]="compareWithFn" [@appearAnimation]="isTmodeUpdated[i] ? 'highlight' : ''">
											<mat-option *ngFor="let tmode of tModes" [value]="tmode.code" [matTooltip]="tmode.description">
												<span >{{tmode.description}}</span></mat-option>
										</mat-select>
									</mat-form-field>
									<mat-form-field subscriptSizing="dynamic" *ngIf="isVariable(i, 'shipToParty') else shipToReadonly" class="copo-content-product card-header-double-span copo-form-field label-padding" (click)="$event.stopPropagation()">
										<mat-label class="label-size" translate>eorder.wizard.order.shipto.name</mat-label>
										<mat-select formControlName="shipToParty" (selectionChange)="onShipToChange(i)" #shipToField [compareWith]="compareWithFn" [@appearAnimation]="isShipToUpdated[i] || getVariableFieldUpdatedState(i, 'shipToParty') ? 'highlight' : ''">
											<mat-option *ngFor="let shipTo of getShipToList()| copoSortOptions:false: configForBoc" [value]="shipTo.businessId">
												<div class="copo-ship-to-name" [matTooltip]="shipTo.name +' / '+ shipTo.city">{{shipTo.name}}&nbsp;/&nbsp;{{shipTo.city}}</div>
												<div class="copo-ship-to-address" *ngIf="shipToField.panelOpen" [matTooltip]="shipTo.address +' '+ (shipTo.postalCode ? shipTo.postalCode : '') + ' ' + shipTo.city + ' (' + shipTo.country + ')'">
													{{shipTo.address}} {{shipTo.postalCode}} {{shipTo.city}} ({{shipTo.country}})
												</div>
											</mat-option>
										</mat-select>
									</mat-form-field>
									<ng-template  #shipToReadonly>
										<div class="card-header-div-block-row2">
											<div class="header-label-row2" translate>eoffer.wizard.delivery.address</div>
											<div class="field-value-row2" [@appearAnimation]="isShipToUpdated[i] || getVariableFieldUpdatedState(i, 'shipToParty') ? 'highlight' : ''" [matTooltip]="getShipTo(i)">{{getShipTo(i)}}</div>
										</div>
									</ng-template>
									<mat-form-field subscriptSizing="dynamic" *ngIf="serviceLevels && serviceLevels.length > 0" class="copo-content-product card-header-double-span copo-form-field label-padding" (click)="$event.stopPropagation()">
										<mat-label class="label-size" translate>global.servicelevel</mat-label>
										<mat-select formControlName="serviceLevel" [compareWith]="compareWithFn" [@appearAnimation]="isServiceLevelUpdated[i] ? 'highlight' : ''">
											<mat-option *ngFor="let serviceLevel of serviceLevels" [value]="serviceLevel.code" [matTooltip]="serviceLevel.description">
												<span>{{serviceLevel.description}}</span></mat-option>
										</mat-select>
									</mat-form-field>
									<mat-form-field subscriptSizing="dynamic" *ngIf="xcarbParamList && xcarbParamList.length > 0" class="copo-content-product card-header-double-span copo-form-field label-padding" (click)="$event.stopPropagation()">
										<mat-label class="xcarb-label label-size" translate>xcarb.label</mat-label>
										<mat-select formControlName="xcarb" [compareWith]="compareWithFn" [@appearAnimation]="isxcarbParamUpdated[i] ? 'highlight' : ''">
											<mat-option *ngFor="let xcarbParam of xcarbParamList" [value]="xcarbParam.code" [matTooltip]="xcarbParam.description">
												<span>{{xcarbParam.description}}</span></mat-option>
										</mat-select>
									</mat-form-field>
									<mat-form-field subscriptSizing="dynamic" *ngIf="businessTypes && businessTypes.length > 0" class="copo-content-product card-header-double-span copo-form-field label-padding" (click)="$event.stopPropagation()">
										<mat-label class="label-size" translate>global.business-type</mat-label>
										<mat-select formControlName="businessType" [compareWith]="compareWithFn" [@appearAnimation]="isBusinessTypeUpdated[i] ? 'highlight' : ''">
											<mat-option *ngFor="let businessType of businessTypes" [value]="businessType.businessCode" [matTooltip]="businessType.businessDescription">
												<span>{{businessType.businessDescription}}</span></mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="card-content-variables">
									<!-- other variable fields -->
									<ng-container *ngIf="getVariablesForThirdRow(i).length > 0" formGroupName="variableFormGroup">
										<div *ngFor="let field of getVariablesForThirdRow(i)" [ngClass]="field.hidden ?'hidden-field':''">
											<mat-form-field subscriptSizing="dynamic" *ngIf="field.type === 'number' " class="copo-content-product card-header-double-span copo-form-field">
												<mat-label>{{getFieldLabel(field.keys)}}</mat-label>
												<input matInput
												copoInputNumber
												[formControlName]="field.keys"
												(change)="simulationCallOnValueChange(i)"
												[formControl]="getVariableFormGroupControl(i, field.keys)"
												[min]="0"
												[max]="99999.9999"
												type="number"
												class="input-field"
												[@appearAnimation]="getVariableFieldUpdatedState(i, field.keys) ? 'highlight' : ''">
												<mat-icon class="pencil-icon pencil-icon-red" svgIcon="copo_pencil" matSuffix></mat-icon>
											</mat-form-field>
											<ng-container *ngIf="field.type === 'string' && field.freeType === true " >
												<mat-form-field subscriptSizing="dynamic" class="copo-content-product card-header-double-span copo-form-field">
													<mat-label>{{getFieldLabel(field.keys)}}</mat-label>
													<input matInput
													[formControlName]="field.keys"
													(change)="simulationCallOnValueChange(i)"
													type="text"
													maxlength="30"
													class="input-field"
													[@appearAnimation]="getVariableFieldUpdatedState(i, field.keys) ? 'highlight' : ''">
													<mat-icon class="pencil-icon pencil-icon-red" svgIcon="copo_pencil" matSuffix></mat-icon>
												</mat-form-field>
											</ng-container>
											<div class="multi-input-group" *ngIf="field.type === 'array'">
												<ng-container *ngIf="field.freeType === false else multiInputFields" [formArrayName]="field.parentVariableName">
													<div *ngFor="let product of getVariableFormArray(i, field.parentVariableName); let j=index; let last=last;">
														<mat-form-field subscriptSizing="dynamic" class="copo-content-product card-header-double-span copo-form-field">
															<mat-label>{{getFieldLabel(field.keys)}}</mat-label>
															<mat-select [formControlName]="j" (selectionChange)="simulationCallOnValueChange(i)" [value]="getVariableFormArrayValueByIndex(i, j, field.parentVariableName)" [compareWith]="compareWithFn"
															[@appearAnimation]="getVariableFieldUpdatedState(i, field.keys, j) ? 'highlight' : ''">
																<mat-option *ngIf="checkIfConfigValueInVariableListMultiItems(field.keys, i, j, field.parentVariableName, field.values)" [value]="getConfigValueMultiItems(field.keys, i, j, field.parentVariableName)"
																	[matTooltip]="getTranslationForCodeByIndexMultiItems(field.keys, i, j, field.parentVariableName)">
																	<span>{{getTranslationForCodeByIndexMultiItems(field.keys, i, j, field.parentVariableName)}}</span>
																</mat-option>
																<mat-option *ngFor="let variableField of field.values| copoSortOptions:false: variableconfig" [value]="variableField.code"
																	[matTooltip]="variableField.value">
																	<span>{{variableField.value}}</span>
																</mat-option>
															</mat-select>
															<div [ngClass]="field.maxItems && field.maxItems > 1 && last && j !== 0 && last && j < (field.maxItems - 1) ? 'multi-input-button-group-3' :'multi-input-button-group-2'" matSuffix tabindex="-1">
																<button type="button" mat-icon-button (click)="$event.stopPropagation(); resetVariableFormArrayValueByIndex(i, j, field.parentVariableName)">
																	<mat-icon class="remove-icon-style" svgIcon="md:close"></mat-icon>
																</button>
																<ng-container *ngIf="field.maxItems && field.maxItems > 1">
																	<button *ngIf="last && j !== 0" type="button" mat-icon-button (click)="$event.stopPropagation(); removeFieldFromVariableFormArray(i, j, field.parentVariableName)">
																		<mat-icon class="remove-icon-style" svgIcon="remove"></mat-icon>
																	</button>
																	<button *ngIf="last && j < (field.maxItems - 1)" type="button" mat-icon-button (click)="$event.stopPropagation(); addFieldToVariableFormArray(i, field.maxItems, field.parentVariableName, field.mandatory, field.hidden)">
																		<mat-icon class="copo-icon-style" svgIcon="plus"></mat-icon>
																	</button>
																</ng-container>
															</div>
														</mat-form-field>
													</div>
												</ng-container>
												<ng-template  #multiInputFields>
													<ng-container [formArrayName]="field.keys">
														<div [ngClass]="field.maxItems && field.maxItems > 1 && last ? (j !== 0 && j < (field.maxItems - 1) ? 'drop-down-group-3' : 'drop-down-group-2'):'drop-down-group-1'" *ngFor="let product of getVariableFormArray(i, field.parentVariableName); let j=index; let last=last;">
															<mat-form-field subscriptSizing="dynamic" class="copo-content-product card-header-double-span copo-form-field">
																<mat-label>{{getFieldLabel(field.keys)}}</mat-label>
																<input matInput
																[formControlName]="j"
																(change)="simulationCallOnValueChange(i)"
																type="text"
																maxlength="30"
																class="input-field"
																[@appearAnimation]="getVariableFieldUpdatedState(i, field.keys, j) ? 'highlight' : ''">
																<mat-icon class="pencil-icon pencil-icon-red" svgIcon="copo_pencil" matSuffix></mat-icon>
																<div [ngClass]="field.maxItems && field.maxItems > 1 && last && j !== 0 && last && j < (field.maxItems - 1) ? 'multi-input-button-group-2' :''" matSuffix tabindex="-1">
																	<ng-container *ngIf="field.maxItems && field.maxItems > 1">
																		<button *ngIf="last && j !== 0" type="button" mat-icon-button (click)="$event.stopPropagation(); removeFieldFromVariableFormArray(i, j, field.parentVariableName)">
																			<mat-icon class="remove-icon-style" svgIcon="remove"></mat-icon>
																		</button>
																		<button *ngIf="last && j < (field.maxItems - 1)" type="button" mat-icon-button (click)="$event.stopPropagation(); addFieldToVariableFormArray(i, field.maxItems, field.parentVariableName, field.mandatory, field.hidden)">
																			<mat-icon class="copo-icon-style" svgIcon="plus"></mat-icon>
																		</button>
																	</ng-container>
																</div>
															</mat-form-field>
														</div>
													</ng-container>
												</ng-template>
											</div>
											<div *ngIf="field.type === 'string' && field.freeType !== true">
												<mat-form-field subscriptSizing="dynamic" class="copo-content-product card-header-double-span copo-form-field">
													<mat-label>{{getFieldLabel(field.keys)}}</mat-label>
													<mat-select [formControlName]="field.keys" (selectionChange)="simulationCallOnValueChange(i)"
														[value]="getVariableFieldValue(i, field.keys)" [compareWith]="compareWithFn"
														[@appearAnimation]="getVariableFieldUpdatedState(i, field.keys) ? 'highlight' : ''">
														<mat-option *ngIf="checkIfConfigValueInVariableList(i, field.keys, field.values)" [value]="getConfigValue(i, field.keys)"
															[matTooltip]="getTranslationForCodeByIndex(field.keys, i)">
															<span>{{getTranslationForCodeByIndex(field.keys, i)}}</span>
														</mat-option>
														<mat-option *ngFor="let variableField of field.values| copoSortOptions:false: variableconfig" [value]="variableField.code"
															[matTooltip]="variableField.value">
															<span>{{variableField.value}}</span>
														</mat-option>
													</mat-select>
													<button type="button" matSuffix mat-icon-button tabindex="-1" (click)="$event.stopPropagation(); resetVariableFieldValue(i, field.keys)">
														<mat-icon class="remove-icon-style" svgIcon="md:close"></mat-icon>
													</button>
												</mat-form-field>
											</div>
										</div>
									</ng-container>
								</div>
								<div>
									<!-- optional tolerance fields -->
									<ng-container *ngIf="getOptionalToleranceFields(i).size > 0" formGroupName="variableFormGroup">
										<div class="tolerance-block" *ngFor="let group of getOptionalToleranceFields(i) | keyvalue">
											<div class="tolerance-group">
											<div class="tolerance-standard" *ngIf="group.value[0].type === 'string' && group.value[0].freeType !== true">
												<mat-form-field subscriptSizing="dynamic" class="copo-content-product card-header-double-span copo-form-field">
													<mat-label>{{getFieldLabel(group.value[0].keys)}}</mat-label>
													<mat-select [formControlName]="group.value[0].keys" (selectionChange)="simulationCallOnValueChange(i)"
														[value]="getVariableFieldValue(i, group.value[0].keys)" [compareWith]="compareWithFn">
														<mat-option *ngIf="checkIfConfigValueInVariableList(i, group.value[0].keys, group.value[0].values)" [value]="getConfigValue(i, group.value[0].keys)"
															[matTooltip]="getTranslationForCodeByIndex(group.value[0].keys, i)">
															<span>{{getTranslationForCodeByIndex(group.value[0].keys, i)}}</span>
														</mat-option>
														<mat-option *ngFor="let variableField of group.value[0].values| copoSortOptions:false: variableconfig" [value]="variableField.code"
															[matTooltip]="variableField.value">
															<span>{{variableField.value}}</span>
														</mat-option>
													</mat-select>
													<button type="button" matSuffix mat-icon-button tabindex="-1" (click)="$event.stopPropagation(); resetVariableFieldValue(i, group.value[0].keys)">
														<mat-icon class="remove-icon-style" svgIcon="md:close"></mat-icon>
													</button>
												</mat-form-field>
											</div>
											<div class="bold-label">
												<span translate>global.or</span>
											</div>
											<div class="tolerance-inner-group">
												<mat-form-field subscriptSizing="dynamic" class="copo-content-product card-header-double-span copo-form-field">
													<mat-label>{{getFieldLabel(group.value[1].keys)}}</mat-label>
													<input matInput
													type="number"
													copoInputNumber
													[formControlName]="group.value[1].keys"
													(change)="simulationCallOnValueChange(i)"
													[formControl]="getVariableFormGroupControl(i, group.value[1].keys)"
													[min]="0"
													[max]="99999.9999"
													class="input-field">
													<mat-icon class="pencil-icon pencil-icon-red" svgIcon="copo_pencil" matSuffix></mat-icon>
												</mat-form-field>
												<mat-form-field subscriptSizing="dynamic" class="copo-content-product card-header-double-span copo-form-field">
													<mat-label>{{getFieldLabel(group.value[2].keys)}}</mat-label>
													<input matInput
													type="number"
													copoInputNumber
													[formControlName]="group.value[2].keys"
													(change)="simulationCallOnValueChange(i)"
													[formControl]="getVariableFormGroupControl(i, group.value[2].keys)"
													[min]="0"
													[max]="99999.9999"
													class="input-field">
													<mat-icon class="pencil-icon pencil-icon-red" svgIcon="copo_pencil" matSuffix></mat-icon>
												</mat-form-field>
											</div>
											</div>
										</div>
									</ng-container>
								</div>
							</ng-template>
						</mat-expansion-panel>
						<mat-expansion-panel *ngIf="isFullyConfigured(i)" [expanded]="isExpanded[i]">
							<ng-template matExpansionPanelContent>
								<div class="card-content">
									<mat-form-field subscriptSizing="dynamic" class="copo-content-product card-header-double-span copo-form-field label-padding">
										<mat-label class="label-size" translate>transport.mode</mat-label>
										<mat-select formControlName="transportMode" [compareWith]="compareWithFn" class="field-content" [@appearAnimation]="isTmodeUpdated[i] ? 'highlight' : ''">
											<mat-option *ngFor="let tmode of tModes" [value]="tmode.code" [matTooltip]="tmode.description">
												<span>{{tmode.description}}</span></mat-option>
										</mat-select>
									</mat-form-field>
									<div class="card-header-div-block-row2">
										<div class="header-label-row2" translate>eoffer.wizard.delivery.address</div>
										<div class="field-value-row2" [matTooltip]="getShipTo(i)">{{getShipTo(i)}}</div>
									</div>
									<mat-form-field subscriptSizing="dynamic" *ngIf="serviceLevels && serviceLevels.length > 0" class="copo-content-product card-header-double-span copo-form-field label-padding">
										<mat-label class="label-size" translate>global.servicelevel</mat-label>
										<mat-select formControlName="serviceLevel" [compareWith]="compareWithFn" class="field-content" [@appearAnimation]="isServiceLevelUpdated[i] ? 'highlight' : ''">
											<mat-option *ngFor="let serviceLevel of serviceLevels" [value]="serviceLevel.code"
												[matTooltip]="serviceLevel.description">
												<span>{{serviceLevel.description}}</span></mat-option>
										</mat-select>
									</mat-form-field>
									<mat-form-field subscriptSizing="dynamic" *ngIf="xcarbParamList && xcarbParamList.length > 0" class="copo-content-product card-header-double-span copo-form-field label-padding" (click)="$event.stopPropagation()">
										<mat-label class="xcarb-label label-size" translate>xcarb.label</mat-label>
										<mat-select formControlName="xcarb" [compareWith]="compareWithFn" [@appearAnimation]="isxcarbParamUpdated[i] ? 'highlight' : ''">
											<mat-option *ngFor="let xcarbParam of xcarbParamList" [value]="xcarbParam.code" [matTooltip]="xcarbParam.description">
												<span>{{xcarbParam.description}}</span></mat-option>
										</mat-select>
									</mat-form-field>
									<mat-form-field subscriptSizing="dynamic" *ngIf="businessTypes && businessTypes.length > 0" class="copo-content-product card-header-double-span copo-form-field label-padding" (click)="$event.stopPropagation()">
										<mat-label class="label-size" translate>global.business-type</mat-label>
										<mat-select formControlName="businessType" [compareWith]="compareWithFn" [@appearAnimation]="isBusinessTypeUpdated[i] ? 'highlight' : ''">
											<mat-option *ngFor="let businessType of businessTypes" [value]="businessType.businessCode" [matTooltip]="businessType.businessDescription">
												<span>{{businessType.businessDescription}}</span></mat-option>
										</mat-select>
									</mat-form-field>
								</div>
							</ng-template>
						</mat-expansion-panel>
					</div>
				</div>
			</div>
		</form>
	</ng-container>
</ng-container>
<ng-template #loadingOrError>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>
<ng-template #simulationLoading>
	<copo-loading-spinner class="simulation-loading"></copo-loading-spinner>
</ng-template>
<ng-template #noProducts>
	<div class="copo-error-label">
		<span translate>eorder.wizard.product.modification.no.products</span>
	</div>
</ng-template>